<template>
  <div class="about-pc">
    <div class="loading-wrap" v-if="!isFinished">
      <el-progress
        type="circle"
        :percentage="percent"
        :stroke-width="10"
        :color="'#306FFF'"
        :width="120"
      ></el-progress>
      <p class="tip">正在检测您的设备与网络, 请稍等</p>
    </div>
    <div class="detect-pass" v-else-if="isFinished && isPass">
      <img class="success-icon" :src="successIcon" />
      <p class="tip tip-success">设备和网络环境检测通过</p>
    </div>
    <div class="detect-fail" v-else>
      <div class="result-item">
        <p class="result-item-detail">
          系统版本：{{ `${pcInfo.OS} ${pcInfo.osVersion}` }}
        </p>
        <p class="result-item-result">
          <img
            class="result-icon"
            :src="osDetectResult.pass ? successIcon : failIcon"
          />
          <span
            :class="{
              pass: osDetectResult.pass,
              fail: !osDetectResult.pass
            }"
          >
            {{ osDetectResult.pass ? '通过' : osDetectResult.tip }}
          </span>
        </p>
      </div>
      <div class="result-item">
        <p class="result-item-detail">
          浏览器: {{ pcInfo.browser }} ({{
            pcInfo.browserVersion.split('/')[1]
          }})
        </p>
        <p class="result-item-result">
          <img
            class="result-icon"
            :src="browserDetectResult.pass ? successIcon : failIcon"
          />
          <span
            :class="{
              pass: browserDetectResult.pass,
              fail: !browserDetectResult.pass
            }"
          >
            {{ browserDetectResult.pass ? '通过' : browserDetectResult.tip }}
          </span>
        </p>
      </div>

      <div class="result-item">
        <p class="result-item-detail">浏览器内核: {{ pcInfo.core }}</p>
        <p class="result-item-result">
          <img
            class="result-icon"
            :src="browserCoreDetectResult.pass ? successIcon : failIcon"
          />
          <span
            :class="{
              pass: browserCoreDetectResult.pass,
              fail: !browserCoreDetectResult.pass
            }"
          >
            {{
              browserCoreDetectResult.pass
                ? '通过'
                : browserCoreDetectResult.tip
            }}
          </span>
        </p>
      </div>
      <div class="result-item">
        <p class="result-item-detail">
          网络：上行网速{{ pcInfo.uploadSpeed }} Mbps 下行{{
            pcInfo.downloadSpeed
          }}
          Mbps
        </p>
        <p class="result-item-result">
          <img
            class="result-icon"
            :src="speedDetectResult.pass ? successIcon : failIcon"
          />
          <span
            :class="{
              pass: speedDetectResult.pass,
              fail: !speedDetectResult.pass
            }"
          >
            {{ speedDetectResult.pass ? '通过' : speedDetectResult.tip }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetectInfo } from '@/utils/detect'
import { sdkUploader } from '@/utils/upload-sdk'
import { Progress } from 'element-ui'
import successIcon from '../assets/success.svg'
import failIcon from '../assets/fail.svg'
import {
  getOsPassInfo,
  getBrowserPassInfo,
  getSpeedTestPassInfo,
  DETECT_STATUS
} from '../helper/deviceDetect.helper'

export default {
  components: {
    ElProgress: Progress
  },
  inject: ['setDetectInfo'],
  data() {
    return {
      detectResource:
        'https://education.codemao.cn/27/exam/1/detect/1596781871000/detect_pic.png',
      resBlob: {},
      percent: 0,
      minSpeed: 0.13,
      pcInfo: {
        uploadSpeed: 0,
        downloadSpeed: 0,
        browser: '',
        browserVersion: '',
        OS: '',
        osVersion: ''
      },
      timer: null,
      isFinished: false,
      successIcon,
      failIcon
    }
  },
  async mounted() {
    this.getDownloadSpeed()
    const detectInfo = getDetectInfo()
    this.pcInfo = Object.assign(this.pcInfo, detectInfo)
    this.listenNetworkChange()
  },
  destroyed() {
    this.timer = null
    this.removeNetworkChange()
  },
  methods: {
    // 获取下载速度
    getDownloadSpeed() {
      this.percent = 0
      const startTime = Date.now()
      const xhr = new XMLHttpRequest()
      const url = `${this.detectResource}?timeslot=${Date.now()}`
      xhr.open('GET', url, true)
      xhr.onload = (data) => {
        const duration = (Date.now() - startTime) / 1000
        const byte = Number(xhr.responseText.length)
        const size = this.byteToMbps(byte)
        const speed = Number((size / duration).toFixed(2))
        // 保证上传与下载资源大小一致
        const blobType = 'text/plain'
        const resBlob = new Blob([data.target.response], {
          type: blobType
        }).slice(0, byte, blobType)
        this.resBlob = resBlob
        this.speed = speed
        this.pcInfo.downloadSpeed = speed
        this.getUploadSpeed(resBlob)
      }
      xhr.onprogress = (data) => {
        const percent = data.loaded / data.total
        this.percent = Number(((percent * 100) / 2).toFixed(2))
      }
      xhr.send()
    },
    byteToMbps(byte) {
      return byte / 1024 / 1024
    },
    uploadProgressCb(res) {
      this.percent = Number((50 + res.total.percent / 2).toFixed(2))
      if (res.total.percent === 100) {
        this.timer = null
        this.timer = setTimeout(() => {
          this.isFinished = true
          this.$emit('detect-finish', this.isPass)

          this.setDetectInfo({
            networkAndDevices: {
              os: {
                result: `${this.pcInfo.OS} ${this.pcInfo.osVersion}`,
                isPass: this.osDetectResult.pass
              },
              browser: {
                result: `${this.pcInfo.browser} (${
                  this.pcInfo.browserVersion.split('/')[1]
                })`,
                isPass: this.browserDetectResult.pass
              },
              browserCore: {
                result: this.pcInfo.core,
                isPass: this.browserCoreDetectResult.pass
              },
              network: {
                result: `上行 ${this.pcInfo.uploadSpeed} Mbps 下行 ${this.pcInfo.downloadSpeed} Mbps`,
                isPass: this.speedDetectResult.pass
              }
            }
          })

          this.percent = 1000
        }, 200)
      }
    },
    uploadCb(res) {
      const duration = (Date.now() - this.uploadTime) / 1000
      const size = this.byteToMbps(this.resBlob.size)
      const speed = Number((size / duration).toFixed(2))
      this.pcInfo.uploadSpeed = speed
      this.$emit('setPcInfo', this.pcInfo)
    },
    errorCb(e) {
      console.log('get upload speed error', e)
    },
    // 获取上传速度
    async getUploadSpeed(blob) {
      this.uploadTime = Date.now()
      const file = new File([blob], 'testUploadSpeed', {
        type: blob.type,
        lastModified: Date.now()
      })
      try {
        await sdkUploader(file, {
          onprogress: this.uploadProgressCb
        })
        this.uploadCb()
      } catch (error) {
        this.errorCb()
      }
    },
    listenNetworkChange() {
      window.addEventListener('online', this.handleNetworkOnline)
      window.addEventListener('offline', this.handleNetworkOffline)
    },
    handleNetworkOnline() {
      this.getDownloadSpeed()
    },
    handleNetworkOffline() {
      this.$message.error('网络异常，请检查网络连接')
    },
    removeNetworkChange() {
      window.removeEventListener('online', this.handleNetworkOnline)
      window.removeEventListener('offline', this.handleNetworkOffline)
    }
  },
  computed: {
    osDetectResult() {
      const r = getOsPassInfo(this.pcInfo.OS, this.pcInfo.osVersion)
      if (r.status === DETECT_STATUS.error) {
        return {
          pass: false,
          tip: r.tip
        }
      } else {
        return {
          pass: true,
          tip: r.tip
        }
      }
    },
    browserDetectResult() {
      const r = getBrowserPassInfo(
        this.pcInfo.browser,
        this.pcInfo.browserVersion
      )
      if (r.detectVersion === DETECT_STATUS.error) {
        return {
          pass: false,
          tip: r.versionTip
        }
      } else {
        return {
          pass: true,
          tip: r.versionTip
        }
      }
    },
    browserCoreDetectResult() {
      const core = this.pcInfo.core
      return {
        pass: core === 'Chromium',
        tip: core === 'Chromium' ? '通过' : '浏览器内核异常'
      }
    },
    speedDetectResult() {
      const r = getSpeedTestPassInfo(
        this.pcInfo.uploadSpeed,
        this.pcInfo.downloadSpeed
      )
      if (r.status === DETECT_STATUS.error) {
        return {
          pass: false,
          tip: r.speedTip
        }
      } else {
        return {
          pass: true,
          tip: r.speedTip
        }
      }
    },
    isPass() {
      return (
        this.osDetectResult.pass &&
        this.browserDetectResult.pass &&
        this.browserCoreDetectResult.pass &&
        this.speedDetectResult.pass
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  width: 320px;
  text-align: center;
  color: rgba(0,0,0,0.45);
  font-size: 14px;
  line-height: 19.6px;
  margin: 12px auto;
  border-radius: 4px;
  padding-top: 4px;
  padding-right: 12px;
  padding-bottom: 4px;
  padding-left: 12px;
}
/deep/ .el-progress-circle {
  path:first-child {
    stroke: #e4f1ff !important;
  }
}
.result {
  margin-top: 36px;
}
.icon-speed-ok {
  width: 164px;
  height: 130px;
  background: url('~@/assets/images/detect/speed-ok.png') center / cover
    no-repeat;
}
.icon-speed-bad {
  width: 154px;
  height: 130px;
  background: url('~@/assets/images/detect/speed-bad.png') center / cover
    no-repeat;
}

.speed-bad {
  .tip {
    color: #ff5030;
  }
}
.btn {
  @include theme-fill-btn(144px, 42px, 16px, 4px);
  margin-top: 38px;
  margin-bottom: 84px;
}
.about-pc {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.success-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.tip-success {
  color: #079455;
}

.detect-fail {
  margin-top: 20px;
}
.result-item {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #242833;
  line-height: 14px;
  margin-left: 10px;
  margin-bottom: 36px;
  width: 466px;
  .result-item-result {
    font-size: 14px;
    width: 150px;
    display: flex;
    align-items: center;
    .result-icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    .pass {
      color: #079455;
    }
    .fail {
      color: #ff5030;
    }
  }
}
</style>
